module.exports = __webpack_public_path__ + "img/DNADamage-BRCA_10X_IDC.5c275ab4.png";